import { DropdownProfile } from '@/components/dropdown/Profile'
import { AutoGraph, EmojiEvent, Lifetime as LifetimeIcon, PickleBall } from '@/components/icons'
import { ROUTE_SIGNUP } from '@/constants/Routes'
import { useOutsideClick } from '@/hooks/useOutsideClick'
import { useAppSelector } from '@/hooks/useRedux'
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useMediaQuery } from 'usehooks-ts'
import { IFrameMobileModal, IFrameModal } from '../../components/modal'
import { DrawerMenu, Footer, Header, MobileHeader, TabletHeader } from '../home/components'
import { userSelector } from '../user/selectors'

export const Lifetime = () => {
  const { user } = useAppSelector(userSelector)
  const isMobile = useMediaQuery('(max-width: 767px)')

  const [openEventIframe, setOpenEventIframe] = useState(false)
  const [showDropdownProfileMenu, setShowDropdownProfileMenu] = useState(false)
  const [openIframe, setOpenIframe] = useState(false)
  const [drawerOpen, setDrawerOpen] = useState(false)

  const handleClickOutside = () => {
    if (!isMobile) setShowDropdownProfileMenu(false)
  }

  const ref = useOutsideClick(handleClickOutside)

  const onToggleEventIframe = () => setOpenEventIframe(!openEventIframe)

  const toggleShowDropdownProfileMenu = () => {
    setShowDropdownProfileMenu(!showDropdownProfileMenu)
  }

  const handleDrawerOpen = () => setDrawerOpen(!drawerOpen)

  const onToggleIframe = () => setOpenIframe(!openIframe)

  useEffect(() => {
    if (showDropdownProfileMenu || openIframe || drawerOpen) {
      document.body.style.overflowY = 'hidden'
    }
    if (!showDropdownProfileMenu && !openIframe && !drawerOpen) {
      document.body.style.overflowY = 'auto'
    }
  }, [showDropdownProfileMenu, openIframe, drawerOpen])

  return (
    <>
      <DrawerMenu drawerOpen={drawerOpen} onDrawerToggle={handleDrawerOpen} />

      <div className="bg-[#f5eeee]">
        <section className="bg-[url('/img/lifetime-bg.png')] flex flex-col justify-between h-screen bg-top bg-no-repeat bg-cover rounded-b-[32px] pb-32 pt-0">
          <TabletHeader toggleShowDropdown={toggleShowDropdownProfileMenu} />
          <MobileHeader onDrawerToggle={handleDrawerOpen} toggleShowProfileMenu={toggleShowDropdownProfileMenu} />
          <div className="container mx-auto relative">
            <Header toggleShowDropdown={toggleShowDropdownProfileMenu} onToggleIframe={onToggleIframe} />
            {user && (
              <div ref={ref}>
                <DropdownProfile
                  isDropdown
                  openDropdown={showDropdownProfileMenu}
                  user={user}
                  dropdownClass="absolute top-[-4rem] right-2 border-t-[1px] lg:top-24 lg:right-5 lg:border-t-[0px]"
                  onRunEvent={() => {
                    setShowDropdownProfileMenu(false)
                    onToggleIframe()
                  }}
                  onCloseModal={toggleShowDropdownProfileMenu}
                />
              </div>
            )}
          </div>
          <div className="container mx-auto flex flex-col items-center justify-end px-4 sm:px-0 max-w-[728px] lg:max-w-[940px]">
            <LifetimeIcon />
            <h1 className="text-white text-xl sm:text-[50px] lg:text-6xl text-center font-bold mt-5 mb-[10px] leading-[130%] px-0 lg:px-10">
              Make Every Match Count With Life Time and DUPR
            </h1>
            <p className="text-white text-base sm:text-[19px] lg:text-2xl sm:leading-9 text-center font-light mb-[10px]">
              LIFE TIME has partnered with the The World’s Most Accurate Pickleball Rating to bring you the best
              matchups for your pickleball experience - whatever your rating or level of play.
            </p>
            <Link
              to={ROUTE_SIGNUP}
              className="bg-primary-500 hover:bg-opacity-70 text-white font-semibold text-sm px-5 py-[14px] rounded-full my-2"
            >
              Sign Up Now
            </Link>
          </div>
        </section>

        <section>
          <div className="max-w-[80rem] mx-auto">
            <div className="flex flex-col px-4 gap-y-4 sm:flex-row sm:gap-x-[10px] lg:px-0 lg:justify-between lg:gap-x-[70px] relative -top-[4.5rem]">
              <div className="bg-white flex flex-1 p-6 flex-col gap-y-[10px] shadow">
                <div className="h-10 flex items-center justify-center">
                  <PickleBall className="w-10 h-full text-navy-900" />
                </div>
                <div className="text-navy-900 text-center text-xl">
                  Find opponents who are exactly at your skill level
                </div>
              </div>
              <div className="bg-white flex flex-1 p-6 flex-col gap-y-[10px] shadow">
                <div className="h-10 flex items-center justify-center">
                  <AutoGraph className="w-10 h-full text-navy-900" />
                </div>
                <div className="text-navy-900 text-center text-xl">Track your progress as you climb up the ratings</div>
              </div>
              <div className="bg-white flex flex-1 p-6 flex-col gap-y-[10px] shadow">
                <div className="h-10 flex items-center justify-center">
                  <EmojiEvent className="w-10 h-full text-navy-900" />
                </div>
                <div className="text-navy-900 text-center text-xl">
                  Sign up to local, regional and national tournaments
                </div>
              </div>
            </div>
          </div>
        </section>

        <section>
          <div className="max-w-[80rem] mx-auto">
            <div className="px-4 sm:px-0">
              <p className="text-2xl text-navy-900 text-center mb-[10px] leading-[150%]">
                Created <span className="text-primary">by and for</span> the pickleball community, DUPR (Dynamic
                Universal Pickleball Rating) is the{' '}
                <span className="text-primary">most accurate and only global pickleball rating system</span> trusted by
                the world's premier Pickleball tours, professionals and clubs — including Life Time Pickleball.
              </p>

              <p className="text-2xl text-navy-900 text-center mb-[10px] pt-8 leading-[150%]">
                All players, <span className="text-primary">regardless of their age, gender, location, or skill,</span>{' '}
                are rated on the same scale between 2.000-8.000 based on their match results.
              </p>
            </div>
          </div>
        </section>

        <section className="mt-24">
          <img
            src="https://assets-global.website-files.com/6494346eebdcf3a7a1a47491/6572af12f828190dadd85964_Group%201.png"
            loading="lazy"
            sizes="100vw"
            srcSet="https://assets-global.website-files.com/6494346eebdcf3a7a1a47491/6572af12f828190dadd85964_Group%201-p-500.png 500w, https://assets-global.website-files.com/6494346eebdcf3a7a1a47491/6572af12f828190dadd85964_Group%201-p-800.png 800w, https://assets-global.website-files.com/6494346eebdcf3a7a1a47491/6572af12f828190dadd85964_Group%201-p-1080.png 1080w, https://assets-global.website-files.com/6494346eebdcf3a7a1a47491/6572af12f828190dadd85964_Group%201-p-1600.png 1600w, https://assets-global.website-files.com/6494346eebdcf3a7a1a47491/6572af12f828190dadd85964_Group%201.png 1728w"
            alt=""
            className="w-full underline"
          ></img>
        </section>

        <section className="py-8 px-4 md:py-12 lg:px-0 lg:py-20 bg-white">
          <div className="max-w-[80rem] mx-auto">
            <div className="text-center">
              <h2 className="text-[28px] sm:text-4xl text-navy-900 font-bold">How Do I Get Started?</h2>
              <p className="w-full sm:w-4/5 mx-auto text-xl leading-7 py-[10px] text-navy-900 font-light">
                DUPR is free and anyone can have a rating. One match result is all it takes to have a DUPR rating, and
                with 10-20 match results you will have an even more accurate rating.
              </p>
            </div>
            <div className="mt-20 flex flex-col gap-y-10 sm:flex-row justify-center gap-x-10">
              <div className="flex flex-col flex-1 gap-y-4">
                <div className="h-auto sm:h-[290px] flex flex-col items-center justify-center gap-y-4">
                  <button
                    onClick={() => {
                      window.open('https://apps.apple.com/us/app/dupr/id1567932355')
                    }}
                  >
                    <img src="img/app_store_logo.svg" className="w-56" />
                  </button>
                  <button
                    onClick={() => {
                      window.open('https://play.google.com/store/apps/details?id=gg.dupr&hl=en&gl=US&pli=1')
                    }}
                  >
                    <img src="img/google_play_logo.png" className="w-56" />
                  </button>
                </div>
                <div className="text-center text-navy-900">
                  <h4 className="font-bold">Step 1</h4>
                  <p className="font-semibold text-2xl my-[10px]">Download the free app and create an account</p>
                </div>
              </div>
              <div className="flex flex-col flex-1 gap-y-4">
                <div className="h-auto sm:h-[290px]">
                  {/* TODO: Update image */}
                  <img src="img/lifetime-img1.jpg" className="h-full w-full" />
                </div>
                <div className="text-center text-navy-900">
                  <h4 className="font-bold">Step 2</h4>
                  <p className="font-semibold text-2xl my-[10px]">Play A Match and Record Results</p>
                </div>
              </div>
              <div className="flex flex-col flex-1 gap-y-4">
                <div className="h-auto flex justify-center sm:h-[290px]">
                  <img src="img/lifetime-img2.jpg" className="h-full" />
                </div>
                <div className="text-center text-navy-900">
                  <h4 className="font-bold">Step 3</h4>
                  <p className="font-semibold text-2xl my-[10px]">Get Your Initial Rating</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section>
          <img
            src="https://assets-global.website-files.com/6494346eebdcf3a7a1a47491/6572bff91463fe4fc84e504e_Group%201.jpg"
            loading="lazy"
            sizes="100vw"
            srcSet="https://assets-global.website-files.com/6494346eebdcf3a7a1a47491/6572bff91463fe4fc84e504e_Group%201-p-500.jpg 500w, https://assets-global.website-files.com/6494346eebdcf3a7a1a47491/6572bff91463fe4fc84e504e_Group%201-p-800.jpg 800w, https://assets-global.website-files.com/6494346eebdcf3a7a1a47491/6572bff91463fe4fc84e504e_Group%201-p-1080.jpg 1080w, https://assets-global.website-files.com/6494346eebdcf3a7a1a47491/6572bff91463fe4fc84e504e_Group%201-p-1600.jpg 1600w, https://assets-global.website-files.com/6494346eebdcf3a7a1a47491/6572bff91463fe4fc84e504e_Group%201.jpg 1728w"
            alt=""
            className="w-full underline"
          />
        </section>

        <section className="py-8 px-4 md:py-12 lg:px-0 lg:py-20 bg-white">
          <div className="max-w-[80rem] mx-auto">
            <div className="text-center">
              <h2 className="text-[28px] sm:text-4xl text-navy-900 font-bold">How is my DUPR rating calculated?</h2>
              <p className="w-4/5 mx-auto text-xl leading-7 py-[10px] text-navy-900 font-light">
                DUPR is a modified Elo algorithm that uses a player’s last rating to update their new rating.
              </p>
            </div>
            <div className="mt-14 flex flex-col gap-y-10 sm:flex-row justify-center gap-x-[30px]">
              <div className="flex flex-col flex-1 gap-y-2 text-navy-900">
                <h1 className="text-xl font-bold text-center">1. Victory:</h1>
                <p className="text-center font-light">
                  Did you win or lose? If you win, your rating will go up and if you lose, your rating will go down.
                </p>
              </div>
              <div className="flex flex-col flex-1 gap-y-2 text-navy-900">
                <h1 className="text-xl font-bold text-center">2. Type of Result:</h1>
                <p className="text-center font-light">
                  Was this a self-posted rec play score, a club match, or a tournament result entered by DUPR? Rec play
                  games will count less towards your rating change.
                </p>
              </div>
              <div className="flex flex-col flex-1 gap-y-2 text-navy-900">
                <h1 className="text-xl font-bold text-center">3. Rating Difference of Opponent:</h1>
                <p className="text-center font-light">
                  If your opponent is higher than you and you win, you’ll increase more than if your opponent is lower
                  rated and vice versa.
                </p>
              </div>
            </div>
          </div>
        </section>

        <section>
          <div className="bg-[url('/img/lifetime-bg1.jpg')] h-[45vh] flex items-center justify-center px-4 lg:px-0 bg-top bg-no-repeat bg-cover">
            <div className="flex flex-col items-center gap-y-2">
              <h2 className="text-2xl sm:text-[42px] text-center leading-7 sm:leading-[50px] text-white font-bold drop-shadow-lg">
                Ready To Up Your Life Time <br />
                Pickleball Experience with DUPR?
              </h2>
              <Link
                to={ROUTE_SIGNUP}
                className="bg-primary-500 hover:bg-opacity-70 text-white font-semibold text-sm px-5 py-[14px] rounded-full my-2"
              >
                Sign Up Now
              </Link>
            </div>
          </div>
        </section>

        <Footer onToggleIframe={onToggleIframe} />

        {isMobile ? (
          <IFrameMobileModal open={openEventIframe} onClose={onToggleEventIframe} />
        ) : (
          <IFrameModal open={openEventIframe} onClose={onToggleEventIframe} />
        )}
      </div>

      {showDropdownProfileMenu && user && (
        <DropdownProfile
          onCloseModal={toggleShowDropdownProfileMenu}
          user={user}
          onRunEvent={() => {
            setShowDropdownProfileMenu(false)
            onToggleIframe()
          }}
        />
      )}

      {isMobile ? (
        <IFrameMobileModal open={openIframe} onClose={onToggleIframe} />
      ) : (
        <IFrameModal open={openIframe} onClose={onToggleIframe} />
      )}
    </>
  )
}
